import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    searchPlaceholder: string;
    searchEmptyState: string;
    searchEmtpyStateQuery: (query: string) => string | React.ReactNode;
    spinnerAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for project search */
            searchPlaceholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceProjectList.searchPlaceholder?c=h565oekm3gd5", defaultMessage: "Find project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state message when no projects match search */
            searchEmptyState: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceProjectList.searchEmptyState?c=as11diiqch87", defaultMessage: "No projects matching" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state query text for search */
            searchEmtpyStateQuery: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (query: string) => __intl__.intl().formatMessage({ id: "WorkspaceProjectList.searchEmtpyStateQuery?c=aka6ziwjznm5", defaultMessage: "\"{query}\"" }, { query: query }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the spinner */
            spinnerAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceProjectList.spinnerAriaLabel?c=25d15suvch2eq", defaultMessage: "Spinner" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
